/* eslint-disable no-param-reassign, array-callback-return, no-underscore-dangle */

import L from 'leaflet';
import { isEmpty } from 'lodash';
import { Roles } from 'meteor/alanning:roles';
import { Meteor } from 'meteor/meteor';

const CONTAINER_STYLE = `
  position: relative;
  color: #000;
  overflow: inherit;
`;

const BUTTON_STYLE = `
  position: absolute;
  bottom: 0px;
  right: calc(3vw + 2em);
  cursor: pointer;
  width: 34px;
  height: 34px;
`;

const IMAGE_STYLE = `
  position: absolute;
  right: 0px;
  bottom: 0px;
  cursor: pointer;
`;
const LOGO_STYLE_FREE = `
  width: 8vw;
  min-width: 3em;
  cursor: pointer;
  filter: drop-shadow(1px -1px 0px #fff) drop-shadow(1px 1px 0px #fff) drop-shadow(-1px 1px 0px #fff) drop-shadow(-1px -1px 0px #fff);
`;
const LOGO_STYLE_PREMIUM = `
  width: 6vw;
  min-width: 3em;
  cursor: pointer;
  filter: drop-shadow(1px -1px 0px #fff) drop-shadow(1px 1px 0px #fff) drop-shadow(-1px 1px 0px #fff) drop-shadow(-1px -1px 0px #fff);
`;

const SPAN_STYLE = `
  position: absolute;
  bottom: 15px;
  color: black;
  overflow: hidden;
  max-width: 0px;
  max-height: 0px;
  transition: max-height 0.5s, max-width 0.3s;
`;

const CUSTOM_URL = `https://srmconsulting.es`;
const userId = Meteor.userId();
const isFree = Roles.userIsInRole(userId, ['free-user']);

const CUSTOM_IMG = isFree ? `/ias-logo/srmFree.png` : `/ias-logo/srm.png`;
const LOGO_STYLE = isFree ? LOGO_STYLE_FREE : LOGO_STYLE_PREMIUM;
const SVG_CC = '<img src="/maps-buttons/c.svg" style="height:100%;width:100%;" />';
const BUTTON_RIGHT = isFree ? '8vw + 1em' : '6vw + 1em';
const SPAN_RIGHT = '1.75rem';

L.Control.CustomMapsAttribution = L.Control.Attribution.extend({
  options: {
    position: 'bottomright',

    prefix: true,

    newUrls: ['', '']
  },
  onAdd(map) {
    // eslint-disable-next-line no-param-reassign
    map.attributionControl = this;
    this._container = L.DomUtil.create('div');
    this._button = L.DomUtil.create('div', 'py-0 px-1', this._container);
    this._img = L.DomUtil.create('div', '', this._container);
    this._span = L.DomUtil.create('span', 'alert-light mb-0 p-0', this._container);

    this._container.style.cssText = CONTAINER_STYLE;
    this._button.style.cssText = BUTTON_STYLE;
    this._img.style.cssText = IMAGE_STYLE;
    this._span.style.cssText = SPAN_STYLE;

    L.DomEvent.disableClickPropagation(this._container);

    Object.keys(map._layers).map(key => {
      if (map._layers[key].getAttribution) {
        this.addAttribution(map._layers[key].getAttribution());
      }
    });

    this._button.title = 'Attribution';
    this._button.clicked = false;
    this._button.innerHTML = SVG_CC;
    if (!this.options.prefix) {
      this._button.style.right = '0px';
      this._button.style.bottom = '-5px';
      this._span.style.right = `calc(${SPAN_RIGHT})`;
    } else {
      this._button.style.right = `calc(${BUTTON_RIGHT})`;
      this._span.style.right = `calc(${BUTTON_RIGHT} + ${SPAN_RIGHT})`;
    }

    this._update();

    L.DomEvent.on(this._button, 'click', this._onButtonClick, this);
    map.on('mouseout', this._spanCollapse, this);
    map.on('click', this._spanCollapse, this);
    return this._container;
  },

  _spanExpand() {
    L.DomUtil.addClass(this._span, 'alert');
    const mapSize = this._map.getSize();
    if (mapSize.x > 600) {
      this._span.style.width = `${mapSize.x / 3}px`;
      this._span.style.maxWidth = `${mapSize.x / 3}px`;
    } else if (mapSize.x < 250) {
      this._span.style.width = 'auto';
      this._span.style.maxWidth = 'auto';
    } else {
      this._span.style.width = '200px';
      this._span.style.maxWidth = '200px';
    }
    setTimeout(() => {
      this._span.style.maxHeight = `${mapSize.y / 2}px`;
    }, 50);
    this._button.clicked = true;
  },

  _spanCollapse() {
    this._span.style.maxHeight = '0px';
    setTimeout(() => {
      this._span.style.maxWidth = '0px';
    }, 200);
    setTimeout(() => {
      L.DomUtil.removeClass(this._span, 'alert');
    }, 500);
    this._button.clicked = false;
  },
  _onButtonClick() {
    if (!this._button.clicked) {
      this._spanExpand();
    } else {
      this._spanCollapse();
    }
  },
  _update() {
    const { prefix, newUrls } = this.options;
    if (!this._map) {
      return;
    }

    const attribs = [];

    Object.keys(this._attributions).map(key => {
      if (this._attributions[key]) {
        attribs.push(key);
      }
    });

    if (prefix) {
      let imgLink;
      let imgSrc;
      if (isEmpty(newUrls[0])) {
        imgLink = CUSTOM_URL;
      } else {
        [imgLink] = newUrls;
      }
      if (isEmpty(newUrls[1])) {
        imgSrc = CUSTOM_IMG;
      } else {
        [, imgSrc] = newUrls;
      }

      this._img.innerHTML = `
          <img
            onclick=window.open("${imgLink}")
            src="${imgSrc}"
            style="${LOGO_STYLE}"
          />
        `;
    }
    if (attribs.length) {
      this._span.innerHTML = attribs.join(' | ');
    } else {
      this._span.innerHTML = 'No attribution';
    }
  }
});

L.control.custommapsattribution = opts => new L.Control.CustomMapsAttribution(opts);

/**
 * Adds the custom attribution in the leaflet map after the map is loaded.
 *
 * @param {object} leafletMap - The leaflet map.
 * @param {boolean} hasPrefix - Option to disable the company logo, if needed.
 * @param {Array} newUrls - Array with the Urls for the logo, if needed.
 */
const customMapsAttribution = (leafletMap, hasPrefix = true, newUrls = ['', '']) => {
  Object.values(document.getElementsByClassName('leaflet-control-attribution')).map(value => {
    value.style.display = 'none';
  });
  L.control.custommapsattribution({ prefix: hasPrefix, newUrls }).addTo(leafletMap);
};

export default customMapsAttribution;
